import {
  login,
  postWeChatBindLogin,
  logout,
  signout,
  getUserInfo,
  getUserProfile,
  updateNickname,
  getVersionNum,
  refreshToken,
  RealNameAuth,
  UpdateToken,
  getRemoteIp,
  getOperationData,
  getClientConfig,
  AgreeExperience,
  setSyncStorage
} from '@/api/home'
import { setToken, removeToken, loginHandleToken, setTokenExpires } from '@/utils/auth'
import dayjs from 'dayjs'
// import { resetRouter } from '@/router'
import isUniversity from '@/utils/isUniversityDomain.js'

let operationDataPromie = null
let clientConfigPromise = null
let userInfoPromise = null
const user = {
  namespaced: true,

  state: {
    leftTo: '',
    taskId: '',
    isSearching: false,
    isShowMenu: false,
    isMobile: false,
    showRealNameDialog: false,
    teenagerslimitType: 'limit', // round, limit
    showTeenagersModel: 'hidden', // hidden, setting, tempunlock
    version: '',
    userInfo: {}, // 用户信息
    hashCode: '',
    code: '',
    applyingPhoneNumber: '', // 是否申请过
    isCollegeUser: {}, // 是否学校用户
    isFisrtViewAfterApply: false, // 是否是申请页面后第一次view
    institution: '', // 某个学校代码，比如'sysu'
    conversationType: 'default', // 'default', 'file'
    documentInfo: {},
    showTryDialog: false, // 未授权用户 试用弹窗
    configuration: {}, // 配置信息
    operationData: {}, // 运营配置信息
    asideIsCollapse: false, // 侧边栏是否折叠
    asideActiveExpand: false, // 侧边栏是否主动展开
    isMiniScreen: false // 是否小屏幕
  },

  getters: {
    vipLevel(state) {
      return state.userInfo?.member_info?.member_status
    },
    vipCtvl(getters) {
      let ctvl
      if (getters.vipLevel === 1) {
        ctvl = 'new'
      } else if (getters.vipLevel === 2) {
        ctvl = 'ing'
      } else if (getters.vipLevel === 3) {
        ctvl = 'old'
      }
      return ctvl
    },
    isBeta(state) {
      return state.userInfo?.trial?.payment
    },
    isSyncStorage(state) {
      return state.userInfo?.setting?.sync_storage
    }
  },

  mutations: {
    SET_ASIDE_IS_COLLAPSE: (state, value) => {
      state.asideIsCollapse = value
    },
    SET_ASIDE_ACTIVE_EXPAND: (state, value) => {
      state.asideActiveExpand = value
    },
    SET_IS_MINI_SCREEN: (state, value) => {
      state.isMiniScreen = value
    },
    SET_LEFT_TO: (state, leftTo) => {
      state.leftTo = leftTo
    },
    SET_IS_FIRST_VIEW_AFTER_APPLY: (state, isFirstViewAfterApply) => {
      state.isFisrtViewAfterApply = isFirstViewAfterApply
    },
    SET_REAL_NAME_DIALOG: (state, value) => {
      state.showRealNameDialog = value
    },
    SET_APPLY_NUMBER: (state, value) => {
      state.applyingPhoneNumber = value
    },
    SET_COLLEGE_STATUS: (state, value) => {
      state.isCollegeUser = value
    },
    SET_USERINFO: (state, value) => {
      state.userInfo = value
    },
    SET_ISMOBILE: (state, value) => {
      state.isMobile = value
    },
    SET_VERSION: (state, value) => {
      state.version = value
    },
    SET_IS_SHOW_MENU: (state, value) => {
      state.isShowMenu = value
    },
    SET_SEARCH_STATUS: (state, value) => {
      state.isSearching = value
    },
    SET_TASK_ID: (state, value) => {
      state.taskId = value
      localStorage.setItem('last_conversation_id', value)
    },
    SET_HASH_CODE: (state, value) => {
      state.hashCode = value
    },
    SET_CODE: (state, value) => {
      state.code = value
    },
    SET_TOKEN: (state, value) => {
      state.code = value
    },
    SET_TEENAGERS_MODEL: (state, value) => {
      state.showTeenagersModel = value
    },
    SET_TEENAGERS_LIMIT_TYPE: (state, value) => {
      state.teenagerslimitType = value
    },
    SET_CONVERSATION_TYPE: (state, value) => {
      state.conversationType = value
    },
    SET_DOCUMENT_INFO: (state, value) => {
      state.documentInfo = value
    },
    SET_SELECT_SCHOOL_MODEL: (state, value) => {
      state.showSelectSchoolModel = value
    },
    SET_INSTITUTION: (state, value) => {
      state.institution = value
    },
    SET_SHOWTRYDIALOG: (state, value) => {
      state.showTryDialog = value
    },
    SET_CONFIGURATION: (state, value) => {
      state.configuration = value
    },
    SET_OPERATION_DATA: (state, value) => {
      state.operationData = value
    }
  },

  actions: {
    // 手机号登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then(res => {
            const { status, result } = res || {}
            // const { permission } = result || {} // permission 该值为0无对话权限，该值为1直接跳转首页
            if (status === 0) {
              loginHandleToken(result)
            }
            resolve(res)
          })
          .catch(error => {
            resolve(error?.data)
            // reject(error)
          })
      })
    },
    // 微信绑定手机号并进行登录
    WeChatLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        postWeChatBindLogin(userInfo)
          .then(res => {
            if (res?.status !== 0) {
              resolve(res)
              return
            }

            loginHandleToken(res.result)
            resolve(res)
          })
          .catch(error => {
            resolve(error?.data)
            // reject(error)
          })
      })
    },
    // 第三方登录更换token
    ThirdLogin({ commit }, saToken) {
      return new Promise((resolve, reject) => {
        UpdateToken(saToken)
          .then(res => {
            const { status, result } = res || {}
            // const { permission } = result || {} // permission 该值为0无对话权限，该值为1直接跳转首页
            !!(status === 0) && loginHandleToken(result)
            resolve(res)
          })
          .catch(error => {
            resolve(error?.data)
            // reject(error)
          })
      })
    },

    // 刷新token
    RefreshToken() {
      return new Promise((resolve, reject) => {
        refreshToken()
          .then(res => {
            const expiresH = dayjs().add(2, 'hour').format('YYYY-MM-DD HH:mm:ss')
            setToken(res.result.accessToken)
            setTokenExpires(expiresH)
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取版本信息 @todo 待删除
    GetVersionNum({ commit, dispatch, state }, options) {
      return new Promise((resolve, reject) => {
        getVersionNum()
          .then(res => {
            commit('SET_VERSION', res.result)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getClientConfig({ commit, _, state }) {
      if (clientConfigPromise) {
        return clientConfigPromise
      }
      // eslint-disable-next-line promise/param-names
      clientConfigPromise = new Promise((resolve, _) => {
        getClientConfig()
          .then(res => {
            if (!res) {
              commit('SET_CONFIGURATION', res.result || {})
              resolve({})
              return
            }
            if (res.status === 0 && res.message === 'success') {
              const result = res.result || {}
              commit('SET_CONFIGURATION', result)
              resolve(result)
            }
          })
          .catch(() => {
            commit('SET_CONFIGURATION', {})
            resolve({})
          })
      })
      return clientConfigPromise
    },

    GetOperationData({ commit, _, state }) {
      if (operationDataPromie) {
        return operationDataPromie
      }
      // eslint-disable-next-line promise/param-names
      operationDataPromie = new Promise((resolve, _) => {
        getOperationData()
          .then(res => {
            if (!res) {
              commit('SET_OPERATION_DATA', res.result || {})
              resolve({})
              return
            }
            if (res.status === 0 && res.message === 'success') {
              const result = res.result || {}
              commit('SET_OPERATION_DATA', result)
              resolve(result)
            }
          })
          .catch(() => {
            commit('SET_OPERATION_DATA', {})
            resolve({})
          })
      })
      return operationDataPromie
    },

    // 获取用户信息
    GetUserInfo({ commit, dispatch, state }, options) {
      const forceUpdate = options?.forceUpdate
      if (userInfoPromise && !forceUpdate) {
        return userInfoPromise
      }
      userInfoPromise = new Promise((resolve, reject) => {
        getUserInfo()
          .then(res => {
            const result = res.result || {}
            if (!isUniversity) {
              result.institution = ''
            }
            commit('SET_USERINFO', { ...state.userInfo, ...result })
            resolve(result)
          })
          .catch(err => {
            if (err !== false && !err?.response && err?.error?.status !== 401) return
            const result = {}
            commit('SET_USERINFO', result)
            // 退出时候清空左侧菜单数据
            commit('Glms/SET_SIDEBAR_LIST', [], { root: true })
            commit('Glms/SET_RECENT_LIST', [], { root: true })
            resolve(result)
          })
      })
      return userInfoPromise
    },

    // 退出系统
    LogOut({ commit, dispatch, state }, options) {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            dispatch('HandleLogOut')
            resolve()
          })
          .catch(error => {
            dispatch('HandleLogOut')
            reject(error)
          })
      })
    },

    // 注销
    SignOut({ commit, dispatch, state }, options) {
      return new Promise((resolve, reject) => {
        signout()
          .then(() => {
            dispatch('HandleLogOut')
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 是否高校用户
    GetColledgeStatus({ commit }) {
      return new Promise((resolve, reject) => {
        getRemoteIp()
          .then(res => {
            // '0'- 高校，‘-1’-外网
            if (res.result && res.result.status_code === '0') {
              commit('SET_COLLEGE_STATUS', res.result)
            }
          })
          .catch(e => {
            console.log(e)
          })
      })
    },

    // 退出系统
    HandleLogOut({ commit, state }) {
      removeToken()
      // resetRouter()
      commit('SET_USERINFO', {})
    },
    // 实名认证
    RealNameAuth({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        RealNameAuth(params)
          .then(res => {
            // 更新userInfo信息
            const { userInfo } = state
            console.log('更新实名认证111')
            commit('SET_USERINFO', { ...userInfo, real_name_identify: true })
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 同意体验
    AgreeExperience({ state, commit }, params) {
      const { userInfo } = state
      return new Promise((resolve, reject) => {
        AgreeExperience(params)
          .then(res => {
            commit('SET_USERINFO', { ...userInfo, agree_experience: true })
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 用户个人属性
    GetUserProfile({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        getUserProfile()
          .then(res => {
            if (res.status === 0 && res.message === 'success') {
              const result = res.result || {}
              resolve(result)
            } else {
              const result = {}
              resolve(result)
            }
          })
          .catch(() => {
            const result = {}
            resolve(result)
          })
      })
    },
    // 用户个人属性
    UpdateNickname({ commit, dispatch, state }, data) {
      return new Promise((resolve, reject) => {
        updateNickname(data)
          .then(res => {
            resolve(res)
          })
          .catch(res => {
            const result = res.data || {}
            resolve(result)
          })
      })
    },
    // 设置同步云盘
    SetSyncStorage({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        setSyncStorage(payload)
          .then(res => {
            if (res.status === 0) {
              dispatch('GetUserInfo', { forceUpdate: true })
                .then(res1 => {
                  resolve(res1)
                })
                .catch(err1 => {
                  reject(err1)
                })
            } else {
              reject()
            }
          })
          .catch(() => {
            reject()
          })
      })
    }
  }
}

export default user
